<template>
  <div class="container is-fluid">
    <Transition>
      <div v-if="showMessage">
        <section>
          <div class="mt-3 mb-3">
            <b-message
              :title="messageTitle"
              type="is-warning"
              has-icon
              aria-close-label="Close"
              size="is-medium"
              v-on:close="toggleMessage"
            >
              {{ messageContent }}
            </b-message>
          </div>
        </section>
      </div>
    </Transition>

    <Transition>
      <div v-if="loading">
        <section class="section is-large">
          <progress class="progress is-large is-primary" max="100" />
        </section>
      </div>
    </Transition>

    <Transition>
      <div v-if="showQuiz">
        <div class="columns">
          <div class="column is-narrow has-text-left">
            <b-sidebar position="static" open>
              <div class="box mt-3">
                <b-menu>
                  <b-menu-list label="Meniu">
                    <b-menu-item
                      label="Încheiere test"
                      icon="lead-pencil"
                      v-on:click="toggleFinalizeTest()"
                    />
                    <b-menu-item label="Întrebări" icon="help-circle">
                      <b-menu-item
                        v-for="(question, index) in questionList"
                        :key="index"
                        :icon="
                          question.has_answer
                            ? 'check-outline'
                            : 'help-circle-outline'
                        "
                        :label="'Întrebarea ' + (index + 1)"
                        :active="index === lastQuestionIndex"
                        v-on:click="getQuestion(index)"
                      />
                    </b-menu-item>
                  </b-menu-list>
                </b-menu>
              </div>
            </b-sidebar>
          </div>
          <div class="column">
            <Transition>
              <div v-if="lastQuestion !== null">
                <question-component
                  v-on:answered="onAnswered"
                  :quizToken="quizToken"
                  :lastQuestion="lastQuestion"
                />
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </Transition>

    <Transition>
      <section v-if="finished" class="section is-large">
        <h1 class="title">Aplicație teste UAS</h1>
        <h2 class="subtitle">Testul s-a încheiat.</h2>
      </section>
    </Transition>

    <Transition>
      <section v-if="showFinalize" class="section is-large">
        <div class="columns is-centered">
          <div class="column is-half">
            <h1 class="title">Vrei să finalizezi testul?</h1>
            <div class="buttons is-centered">
              <b-button
                type="is-danger is-light"
                v-on:click="toggleFinalizeTest"
              >
                Nu
              </b-button>
              <b-button type="is-success" v-on:click="finalizeTest">
                Da
              </b-button>
            </div>
          </div>
        </div>
      </section>
    </Transition>

    <Transition>
      <div v-if="isInvalid">
        <section class="section is-large">
          <h1 class="title">Aplicație teste UAS</h1>
          <h2 class="subtitle">Utilizatorul nu a selectat un test valid.</h2>
        </section>
      </div>
    </Transition>
  </div>
</template>

<script>
import QuestionComponent from "./QuestionComponent.vue";
import RestResource from "../services/one-api.js";
export default {
  components: { QuestionComponent },
  methods: {
    sendMessage(message) {
      this.toggleMessage();
      this.messageContent = message;
      this.showMessage = true;
    },

    toggleMessage() {
      this.showMessage = false;
      this.messageContent = "";
    },

    async toggleFinalizeTest() {
      await this.getQuestion(this.lastQuestionIndex);

      this.showQuiz = !this.showQuiz;
      this.showFinalize = !this.showFinalize;
    },

    async finalizeTest() {
      let restData = await this.runWf(
        "DroneExamAux",
        "finalizeTest",
        {
          token: this.quizToken
        }
      );
      if (restData === null) {
        return;
      }
      this.finished = true;
      this.showFinalize = false;
      window.parent.postMessage({frameName: window.name, eventName: 'homeRefresh'}, '*');
      window.parent.postMessage({frameName: window.name, eventName: 'close'}, '*');
    },

    async runWf(wfName, wfMethod, args) {
      let restData = null;
      try {
        restData = await this.restService.workflow(wfName, wfMethod, args);
      } catch (err) {
        this.sendMessage(err);
        return null;
      }
      return restData;
    },

    async onAnswered(answered, question) {
      let answer = {
        id_answer: question.id_answer,
        answer_hash: answered,
      };

      let restData = await this.runWf("DroneExamAux", "saveAnswer", {
        answer: answer,
      });
      if (restData === null) {
        return;
      }

      this.questionList[question.questionIndex].has_answer = true;
      let nextIndex = question.questionIndex + 1;
      await this.getQuestion(nextIndex);
    },

    async getQuestion(questionIndex) {
      if (questionIndex === this.questionList.length) {
        this.showQuiz = !this.showQuiz;
        this.showFinalize = !this.showFinalize;
        return;
      }

      this.lastQuestionIndex = questionIndex;

      this.lastQuestion = null;

      let restData = await this.runWf("DroneExamAux", "getExamQuestion", {
        exam_token: this.quizToken,
        id_answer: this.questionList[questionIndex].id_answer,
      });

      if (restData === null) {
        return;
      }
      
      restData.data.questionIndex = questionIndex;
      this.lastQuestion = restData.data;
    },

    async getQuestionList() {
      let restData = await this.runWf("DroneExamAux", "getExamQuestions", {
        exam_token: this.quizToken,
      });

      if (restData === null) {
        return;
      }

      this.questionList = [];

      if (restData.data !== null) {
        restData.data.sort(function (a, b) {
          let keyA = a.id_answer;
          let keyB = b.id_answer;
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        this.questionList = restData.data;

        if (this.questionList.length > 0) {
          await this.getQuestion(0);
        }
      }
    },
  },
  async mounted() {
    this.restService = RestResource(this.axios);

    if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
      this.quizToken = this.$route.params.id;
      await this.getQuestionList();
      this.loading = false;
      if (this.questionList.length > 0) {
        this.showQuiz = true;
      } else {
        this.finished = true;
      }
      return;
    }

    this.isInvalid = true;
  },
  data() {
    return {
      restService: null,

      quizToken: null,

      questionList: [],
      lastQuestionIndex: null,

      lastQuestion: null,

      finished: false,
      showFinalize: false,
      showQuiz: false,
      isInvalid: false,

      loading: true,

      messageTitle: "Mesaj eroare",
      messageContent: "",
      showMessage: false,
    };
  },
};
</script>
<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
